import styled from "styled-components";

interface OcrFrameProps {
  iframeAccess?: boolean;
}

export const OcrFrame = styled.iframe<OcrFrameProps>`
  width: 100%;
  height: ${(props) => (props.iframeAccess ? "500px" : "530px")};
  border: 0;
`;

const OCR_SLOT_HEIGHT = "620px";

const MOBILE_SIDE_PADDING = "16px";

export const OcrSlot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: ${OCR_SLOT_HEIGHT};
  align-self: stretch;

  @media (max-width: 500px) {
    position: absolute;
    inset: 0;
    height: auto;
    padding-left: ${MOBILE_SIDE_PADDING};
    padding-right: ${MOBILE_SIDE_PADDING};
  }
`;

export const OcrError = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  background-color: #ffcbcb;
  padding: 8px;
  border-radius: 8px;
  margin-top: 16px;
  margin-left: 1.5rem;
  margin-right: 1.5rem;

  @media (max-width: 500px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`;

export const OcrErrorImageContainer = styled.div`
  background-color: white;
  border-radius: 8px;
`;

export const OcrErrorImage = styled.img`
  width: 58px;
  height: 58px;
  object-fit: contain;
`;

export const OcrErrorText = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
    // text-align: center
  color: #B00B0B;
  margin: 0px;
  width: 100%;
`;
